var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCultureIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8132_16003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.013 6.40321L7.50552 8.88618C6.77655 9.12637 5.97498 8.82613 5.59084 8.1656C5.11897 7.35796 5.43657 6.32214 6.28049 5.91082L16.1745 1.104H28.0528V6.40321L22.0426 9.3005H15.6754C14.8678 9.3005 14.2145 8.65199 14.2145 7.85035C14.2145 7.04872 14.8678 6.4002 15.6754 6.4002H19.5955",
    stroke: "#0D4248",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4126 23.9071L25.9201 21.4241C26.649 21.1839 27.4506 21.4841 27.8347 22.1447C28.3066 22.9523 27.989 23.9881 27.1451 24.3995L17.248 29.2063H5.36975V23.9071L11.38 21.0098H17.7471C18.5547 21.0098 19.2081 21.6583 19.2081 22.4599C19.2081 23.2615 18.5547 23.9101 17.7471 23.9101H13.827",
    stroke: "#0D4248",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.426 11.7569C17.3673 10.706 15.6463 10.706 14.5876 11.7569C13.5289 12.8077 13.5289 14.5161 14.5876 15.5669L18.426 19.3769L22.2645 15.5669C23.3231 14.5161 23.3231 12.8077 22.2645 11.7569C21.2058 10.706 19.4847 10.706 18.426 11.7569Z",
    stroke: "#0D4248",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8132_16003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5932,
    height: 29,
    fill: "white",
    transform: "translate(4.91467 0.653809)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCultureIcon4);
export default __webpack_public_path__ + "static/media/culture-icon-4.69399a2973152381adfc599d87a63f29.svg";
export { ForwardRef as ReactComponent };